import React, { useEffect, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux';
import LoadingSpinner from '../CommonComponents/loadingSpinner';
import { clearLastMonthBilling } from '../../Actions/clearLastMonthBillingAction';
import { PARTNER_TYPE_AFFILIATE } from '../PartnerPortal/leftNavbar';

const TopBanner = () => {
  const [showBanner, setShowBanner] = useState(false);
  const [loading, setLoading] = useState(false);
  const partnerDetails = useSelector(state => state.partnerDetails);
  const dispatch = useDispatch();

  const lastMonthBilling = useSelector(state => state.lastMonthBilling);

  const isAffiliate = partnerDetails?.partnerType === PARTNER_TYPE_AFFILIATE;

  useEffect(() => {
    if(lastMonthBilling !== null && !lastMonthBilling.isPaid()) {
      setShowBanner(true);
    }
  }, [lastMonthBilling])

  useEffect(() => {
    setLoading(false)
  }, [lastMonthBilling]);

  const closeBanner = () => {
    setShowBanner(false);
  }

  const chargeHandler = () => {
    setLoading(true);
    dispatch(clearLastMonthBilling(partnerDetails?.id));
  };

  if(isAffiliate || !showBanner)
    return <></>;

  return (
    <div id="alert-banner" class={"warning-charge-failed-banner d-flex justify-content-center "}>
        <div class="alert-banner-wrapper">
            <div class="text-banner-div">
                <span class="text-banner-span" id="charge-failed-acc-block-warning-span">
                    We were NOT able to charge you for last month's payment. Please pay now to avoid account disruptions.
                </span>
            </div>

            <div class="action-banner-div">
                <div class="banner-btn block-pay-now">
                    <button class="btn banner-clear-due-btn" onClick={chargeHandler}>Charge now</button>
                </div>
            </div>
        </div>
        <div class="close-div-banner">
            <span class="material-icons" onClick={closeBanner}>clear</span>
        </div>

        {loading && <LoadingSpinner target={"partner-portal-wrapper"} />}
    </div>
  )
}

export default TopBanner